import { Col, Row } from "antd";
import InputNumberComponent from "../../../components/InputNumberComponent";
import { useDocumentContext } from "../../../context/DocumentContext/DocumentContext";
import { useEffect, useState } from "react";
import InputComponent from "../../../components/InputComponent";


const DocumentInfo = () => {
	const { documentUpdate, documentDetail, setDocumentUpdate } = useDocumentContext();
	const [displayOrderValue, setDisplayOrderValue] = useState<number | undefined>(undefined);
	const [documentNameValue, setDocumentNameValue] = useState<string>("");

	useEffect(() => {
		if (!documentDetail) {
			return;
		}

		setDisplayOrderValue(documentDetail.displayOrder);
		setDocumentNameValue(documentDetail.name);
	}, [documentDetail]);

	return (
		<>
			<Row gutter={20}>
				<Col span={5}>
					<InputNumberComponent
						title={"Sıra No"}
						placeholder=""
						positiveOnly
						value={displayOrderValue}
						onChange={(value) => {
							const nextValue = value === null ? undefined : Number(value);
							setDisplayOrderValue(nextValue);
							setDocumentUpdate({
								...documentUpdate,
								displayOrder: nextValue
							});
						}}
					/>
				</Col>
				<Col span={15}>
					<InputComponent
						title={"Doküman Adı"}
						placeholder="Tamim No 5"
						value={documentNameValue}
						onChange={(e) => {
							const nextValue = e.target.value;
							setDocumentNameValue(nextValue);
							setDocumentUpdate({
								...documentUpdate,
								documentName: nextValue
							});
						}}
					/>
				</Col>
			</Row >
		</>
	);
};

export default DocumentInfo;
